import { render, staticRenderFns } from "./SectionShopPost.vue?vue&type=template&id=e271d610&scoped=true&lang=pug&"
import script from "./SectionShopPost.vue?vue&type=script&lang=js&"
export * from "./SectionShopPost.vue?vue&type=script&lang=js&"
import style0 from "./SectionShopPost.vue?vue&type=style&index=0&id=e271d610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271d610",
  null
  
)

export default component.exports